export const HOST_BASE_URL = `${window.location.protocol}//${
  window.location.hostname
}${window.location.port ? `:${window.location.port}` : ''}`;

export const normalizeUrl = (baseUrl: string, endpoint: string) => new URL(endpoint, baseUrl).toString();
